import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  cardsWrapper: {
    margin: '24px 40px',
    padding: '20px'
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
    margin: '30px 40px',
    height: '100%',
  },
  selectMessageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '70vh',
    color: '#F37320',
    fontSize: '20px',
    fontWeight: '600',
    textAlign: 'center'
  },
  accountSelector: {
    backgroundColor: '#F37320',
    color: '#ffffff'
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px'
  },
  formContainer: {
    margin: '0 40px',
    padding: '20px 40px',
  },
  buttonContainer: {
    display: 'flex',
    marginTop: '20px'
  },
  button: {
    maxWidth: 220,
  },
  primaryButton: {
    color: 'white',
    marginRight: '20px'
  },
  userHeaderWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: '20px 20px',
  },
  mr4: {
    marginRight: '2rem',
  },
  mt4: {
    marginTop: '60px',
  },
  cardTitle: {
    marginBottom: '15px',
    fontSize: '20px',
    color: '#545456'
  },
  submitButton: {
    maxWidth: '220px',
    color: 'white',
    float: 'right',
    margin: '5px'
  },
  cancelButton: {
    maxWidth: '220px',
    float: 'right',
    margin: '5px'
  },
  summaryheaderWrapper: {
    backgroundColor: '#F7F7F7',
    padding: '0.5rem',
    color: '#F37320',
    fontWeight: 'bold',
    fontSize: '20px'
  },
  cardWrapper: {
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
  },
  center: {
    alignItems: 'center',
    height: '200px'
  },
  card: {
    margin: '20px 10px',
    padding: '15px 25px',
    width: '100%',
    maxWidth: '250px'
  },
  cardData: {
    fontSize: '12px',
    color: '#6F6F6F',
    paddingBottom: '5px'
  },
  cardValue: {
    fontSize: '20px'
  },
  comingsoon: {
    fontSize: '20px',
    color: '#F37320',
    fontWeight: 'bold'
  },
  popoverButton: {
    width: '100%',
    minWidth: '250px',
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',
    minWidth: '250px',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  paperText: {
    textTransform: 'none',
    wordBreak: 'break-word',
    fontWeight: 500
  },
  selectbox: {
    minWidth: 180,
    width: '100%'
  },
  white: {
    color: 'white',
  },
  selectRoot: {
    color: 'white',
    backgroundColor: '#F37320'
  },
  border: {
    border: 'none'
  },
  refreshIcon: {
    verticalAlign: 'middle',
    cursor: 'pointer'
  },
  input: {
    '@media (min-width: 3000px)': {
      '& svg': {
        top: 'calc(50% - 25px)'
      }
    }
  },
  buttonWrapper: {
    display: 'flex', 
    justifyContent: 'space-between',
    alignItems: 'center'
  }
  
}))

export { useStyles }